module.exports = "/fast-coin/img/coin/anim/out_2/out_2_009.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_2/out_2_009.png
// module id = 2315
// module chunks = 5